import { Stack, Typography } from "@mui/material";
import type { BadgeProps } from "@mui/material/Badge";
import BadgeDetached from "@entrilia/shared/components/BadgeDetached";

interface TabLabelWithCountProps {
  label: string;
  count: number;
  total?: number;
  isActive?: boolean;
  hideCounter?: boolean;
  showZero?: boolean;
  badgeColor?: BadgeProps["color"];
}

const TabLabelWithCount = ({
  label,
  count,
  total,
  isActive,
  hideCounter,
  showZero,
  badgeColor,
}: TabLabelWithCountProps) => {
  const badgeContent = total === undefined || count === total ? count : `${count} / ${total}`;
  return (
    <Stack direction={"row"} spacing={1} sx={{ alignItems: "center" }}>
      <Typography variant="subtitle2">{label}</Typography>
      {!hideCounter && (
        <BadgeDetached
          color={badgeColor ?? (isActive ? "primary" : "secondary")}
          badgeContent={badgeContent}
          showZero={showZero}
        />
      )}
    </Stack>
  );
};

export default TabLabelWithCount;
